import { Box, Checkbox } from '@openfin/ui-library';
import { Field, FieldProps } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { BooleanField, CheckboxWidgetSpec } from '../../../../../client';

interface Props {
  field: BooleanField<CheckboxWidgetSpec>;
}

export const CheckboxWidgetComponent = (props: Props): JSX.Element => {
  const { key, label } = props.field;
  return (
    <Field name={key}>
      {({ field }: FieldProps) => (
        <Wrapper>
          <Checkbox {...field} checked={field.value} label={label} />
        </Wrapper>
      )}
    </Field>
  );
};

const Wrapper = styled(Box)`
  width: 100%;
`;
